@if (uiController === UIControlTyp.MultiSelectList) {
  <kendo-multiselect
    textField="name"
    valueField="id"
    [data]="ProjectTypeList"
    [filterable]="true"
    (filterChange)="filteTypeList($event)"
    [(ngModel)]="ProjectTypes"
    placeholder="Wählen Sie einen Wert aus"
    (valueChange)="valueChanged()">
  </kendo-multiselect>
}
@if (uiController === UIControlTyp.DropDownList) {
  <kendo-dropdownlist
    class="fdb-kendo-dropdown"
    textField="name"
    valueField="id"
    [valuePrimitive]="true"
    [data]="ProjectTypeList"
    [value]="SelectedProjectTypeId"
    (valueChange)="valueChanged($event)">
  </kendo-dropdownlist>
}
@if (uiController === UIControlTyp.GridSingleValueField) {
  {{ getName() }}
}
